module.exports = __webpack_public_path__ + "img/enfermera-icon.d18f4fe6.png";